import { connect } from "react-redux";
import { compose } from "recompose";
import { getCommands } from "src/modules/command/duck/selectors";

import CommandsGroup from "./CommandsGroup";

function mapStateToProps(state) {
  return {
    commands: Object.values(getCommands(state))
  };
}

const enhance = compose(connect(mapStateToProps));

export default enhance(CommandsGroup);
